// @flow
import React from 'react';
import { useFormikContext } from 'formik';
import { useParams } from 'react-router-dom';

import { ENABLE, NATIVE_INFERENCE_POOL_ENABLED_BACKEND_NAME } from '../../../constants';
import { CheckBoxField } from '../../../formik-utils/FormFields';
import { toastError } from '../../presentational/notifications/utils';
import { useEstimateVersion } from '../../../custom-hooks/useEstimateVersion';
import {
  useDisableNativeInferencePoolMutation,
  useEnableNativeInferencePoolMutation,
} from '../../../service-definitions/estimates';

export const NativeInferencePoolEnabledContainer = ({
  nativeInferencePoolId = null,
  checked = null,
  addLabel = true,
}) => {
  const { isValid } = useFormikContext();
  const { estimateId, nativeInferencePoolId: nativeInferencePoolIdComingFromParams } = useParams();
  const nativeInferencePoolIdToUse = nativeInferencePoolId
    ? nativeInferencePoolId
    : nativeInferencePoolIdComingFromParams;
  const estimateVersion = useEstimateVersion();
  const [enableNativeInferencePool] = useEnableNativeInferencePoolMutation();
  const [disableNativeInferencePool] = useDisableNativeInferencePoolMutation();

  const checkedProps = checked != null ? { checked } : {};
  return (
    <CheckBoxField
      addLabel={addLabel}
      disabled={!isValid}
      fieldDisplayName={ENABLE}
      fieldName={NATIVE_INFERENCE_POOL_ENABLED_BACKEND_NAME}
      icon={null}
      onChange={async (event, value, setFieldValue, setFieldTouched, values, checked) => {
        const payload = {
          id: nativeInferencePoolIdToUse,
          estimate_id: estimateId,
          estimate_version: estimateVersion,
        };

        const funcToCall = checked ? enableNativeInferencePool : disableNativeInferencePool;

        const { error } = await funcToCall({
          estimateId,
          nativeInferencePoolId: nativeInferencePoolIdToUse,
          payload,
        });

        if (error) {
          toastError(error);
        }
      }}
      {...checkedProps}
    />
  );
};
